import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import titleActions from 'website/containers/entity/titleActions';
import titleRating from 'website/containers/entity/titleRating';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userRating from 'website/containers/user-action/userRating';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import reviewsSocial from 'website/containers/user/reviewsSocial';
import loadOutbrain from 'website/module/advertisement/outbrain';
// import player
import initPlayer from 'website/module/player';
import initPlayerExport from 'website/module/player/export';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
// import share
import initMoreTriggerOverlay from 'website/module/ui/more-trigger-overlay';
import thirdNav from 'website/module/ui/third-nav';

applicationBootstrap().then(() => {
  initMoreTriggerOverlay();
  initPlayer();
  initPlayerExport();

  titleActions();

  thirdNav();

  dropdownLinks();

  titleRating();

  userOpinion();
  userReviewLink();

  reviewsSocial();

  roller();

  userRating();

  facebookWidgets();

  loadOutbrain();

  socialActionsBootstrap();
});
